export default __webpack_public_path__ + "static/media/social_google.1bc49de3.svg";